/**
 * HelpModal — short guide to the kitchen, opened from the footer and Ask.
 */
import { Button, Modal, ModalBody, ModalHeader } from '../design-system/primitives/index.js'

export default function HelpModal({ isOpen, onClose }) {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      titleId="help-title"
      describedById="help-lead"
      overlayClassName="modal-overlay--elevated"
      contentClassName="help-modal-content"
    >
      <ModalHeader>
        <h2 id="help-title">Help</h2>
        <Button
          type="button"
          variant="ghost"
          onClick={onClose}
          className="modal-close"
          aria-label="Close help"
        >
          ×
        </Button>
      </ModalHeader>
      <ModalBody>
        <p id="help-lead" className="help-lead">
          Keep the recipes you already love in one place. Plan dinners from the pantry, fridge, and freezer, and shop only for what’s missing.
        </p>

        <section className="help-section">
          <h3><i className="fas fa-box-open icon-md icon-primary" aria-hidden="true" /> Pantry</h3>
          <p>Add what’s in the pantry, fridge, and freezer. Type items, or paste a receipt after you shop.</p>
        </section>

        <section className="help-section">
          <h3><i className="fas fa-utensils icon-md icon-primary" aria-hidden="true" /> Recipes</h3>
          <p>Paste a link, paste the recipe, upload a photo, or add a pack. They stay in Recipes.</p>
        </section>

        <section className="help-section">
          <h3><i className="fas fa-calendar-week icon-md icon-primary" aria-hidden="true" /> Plan</h3>
          <p>Put dinners on the week, favoring what you can cook sooner.</p>
        </section>

        <section className="help-section">
          <h3><i className="fas fa-shopping-cart icon-md icon-primary" aria-hidden="true" /> Shop</h3>
          <p>
            One list of what you still need, from the dinners you planned. Add anything else by name, and check items off as you shop. Choose your store when you want the list by aisle. When you’re done, update the pantry from this shop.
          </p>
        </section>

        <section className="help-section">
          <h3><i className="fas fa-fire icon-md icon-primary" aria-hidden="true" /> Cook</h3>
          <p>Open Cook Mode for the dinner you’re making. It walks the steps.</p>
        </section>

        <section className="help-section">
          <h3><i className="fas fa-comment icon-md icon-primary" aria-hidden="true" /> Ask the Cook</h3>
          <p>Create an account, then ask about a recipe, the pantry, the week, or the list.</p>
          <ul className="help-examples" aria-label="Example questions">
            <li>“What can I cook from what’s on hand?”</li>
            <li>“What’s still missing for Thursday?”</li>
          </ul>
        </section>

        <section className="help-section">
          <h3><i className="fas fa-user icon-md icon-primary" aria-hidden="true" /> Your account</h3>
          <p>Create an account to keep your recipes, pantry, plan, and list.</p>
        </section>
      </ModalBody>
    </Modal>
  )
}
